/* eslint-disable react/prop-types */
/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/styles";
import {
  Divider,
  TextField,
  Button,
  Grid,
  Paper,
  IconButton,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import CustomDataGrid from "../../../../components/CustomDataGrid/CustomDataGrid";
import { IsEmpty } from "../../../../utils/helper";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CustomizedFileDownloader from "./CustomizedFileDownloader";
import TrayBarcodeTablePopup from "./TrayBarcodeTablePopup";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    minHeight: 92,
    // maxHeight: 300,
  },

  itemCard: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    width: "98%",
    marginTop: 10,
    overflow: "visible",
    backgroundColor: "#f2f2f2",
    cursor: "pointer",
    marginBottom: 10,
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 14,
    marginTop: 5,
    //width: "80%",
    marginLeft: 20,
  },
  itemTitle: {
    color: "#3f51b5",
    fontSize: 15,
    marginRight: 5,
    textAlign: "left",
  },
  itemSubTitle: {
    fontSize: 15,
    whiteSpace: "nowrap",
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "100%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 20,
  },
  itemCardTitleDivider: {
    width: "100%",
    backgroundColor: "grey",
    opacity: "0.5",
  },
  cardContent: {
    padding: 0,
    width: "100%",
    marginLeft: 10,
    marginRight: 10,
    overflow: "auto",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  itemCardContent: {
    padding: 0,
    width: "90%",
    marginLeft: 20,
    marginTop: 10,
    minHeight: 280,
    maxHeight: 280,
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  },

  listItem: {
    outline: "none",
    cursor: "pointer",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
  },
  listItemContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  listItemKey: {
    fontSize: 14,
    textAlign: "left",
    fontWeight: 600,
    width: "25%",
  },
  listItemValue: {
    fontSize: 13,
    textAlign: "left",
    width: "25%",
  },
  halfWidthRight: {
    width: "50%",
    textAlign: "right",
  },
  subListItemContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  totalAmount: {
    fontSize: 14,
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginRight: 10,
  },
  barcodeImage: {
    display: "flex",
    width: "100%",
    justifyContent: "end",
  },
  circularProgressStyle: {
    marginTop: 10,
  },
  itemCardContentTitle: {
    fontSize: 14,
    fontWeight: 700,
    textDecoration: "underline",
  },
  itemCardItemTitle: {
    fontSize: 14,
    fontWeight: 700,
    textAlign: "left",
    marginTop: 10,
    marginBottom: 10,
  },
  listItemActive: {
    backgroundColor: "#ffdddd !important",
  },
  headerblack: {
    color: "red",
  },
  headerblue: {
    color: "blue",
  },
  input1: {
    // height: 15,
    width: "70%",
  },
});

class SalesTab extends React.Component {
  textFieldRef = null;
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { name: "Name", title: "Name" },
        { name: "Copies", title: "Copies" },
        { name: "PageStyle", title: "Page Style" },
        { name: "Lamination", title: "Lamination" },
        { name: "Bundles", title: "Bundles" },
        { name: "Packaging", title: "Packaging" },
        // { name: "action", title: "Action" }
      ],
      dispatchColumns: [
        { name: "deliveryPartnerLabel", title: "Delivery Partner" },
        { name: "consignmentNo", title: "CN #" },
        { name: "bookingDate", title: "Booked On" },
        { name: "dispatchDate", title: "Dispatched On" },
      ],
      shipmentColumns: [
        { name: "deliveryPartnerLabel", title: "Delivery Partner" },
        { name: "consignmentNo", title: "CN #" },
        { name: "dispatchDate", title: "Dispatched On" },
        { name: "deliveryDate", title: "Delivered On" },
      ], // Adjust the offset value as needed

      isOpenTrayList: false,

      rows: [
        {
          trayBarcode: "TRAY1234",
          isAssigned: 1,
          assignedOrderId: "ORD5678",
          assignedOn: "2025-01-15",
        },
        {
          trayBarcode: "TRAY5678",
          isAssigned: 0,
          assignedOrderId: "",
          assignedOn: "",
        },
      ],
    };
  }

  handleTrayListOpen = async (e, isOpen) => {
    if (!IsEmpty(e)) {
      e.preventDefault();
    }
    if (isOpen) {
      await this.props.getTraysData();
    }
    this.setState({
      isOpenTrayList: isOpen,
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.columns !== prevProps.columns) {
      this.setState({
        columns: this.props.columns,
      });
    }

    if (this.props.values.filterStatus == 13) {
      const salesDataObj = this.props.values.selectedSalesData || {};
      if (!IsEmpty(salesDataObj)) {
        setTimeout(() => {
          if (this.textFieldRef != null && !IsEmpty(this.textFieldRef)) {
            this.textFieldRef.focus();
          }
        }, 1000);
      }
    }
  }

  render() {
    const { classes } = this.props;

    const salesDataObj = this.props.values.selectedSalesData || {};

    const isTrayAssigned = !IsEmpty(salesDataObj)
      ? salesDataObj.isTrayAssigned || 0
      : 0;

    const isSummaryDownloaded = !IsEmpty(salesDataObj)
      ? salesDataObj.isSummaryDownloaded || 0
      : 0;

    const summaryPDfFile =
      isSummaryDownloaded == 1 ? salesDataObj.summaryPDfFile || "" : "";
    console.log("RENDER summaryPDfFile", summaryPDfFile);

    const trayLabel = !IsEmpty(salesDataObj)
      ? salesDataObj.trayLabel || ""
      : "";

    return (
      <React.Fragment>
        <TrayBarcodeTablePopup
          open={this.state.isOpenTrayList}
          onClose={(e) => this.handleTrayListOpen(e, false)}
          rows={this.props.values.traysData}
        />
        {!IsEmpty(this.props.values.salesData) && (
          <Card className={classes.card}>
            <CardContent style={{ padding: 0 }}>
              {!IsEmpty(this.props.values.salesData) &&
                this.props.values.salesData[0].isRemarks == 1 && (
                  <>
                    <span
                      style={{
                        marginRight: 10,
                        marginBottom: 5,
                        color: "black",
                      }}
                      className={classes.title}
                    >
                      <b> Created By : </b>{" "}
                      {this.props.values.salesData[0].createdBy}
                      <b style={{ marginLeft: 10 }}>Remarks : </b>{" "}
                      {this.props.values.salesData[0].remarks}
                    </span>
                    {/* <span  style={{ marginRight: 10,marginBottom:5,color:"black"}} className={classes.title}>
                       
                  </span> */}
                    <Divider className={classes.titleDivider} />
                  </>
                )}
              {this.props.values.filterStatus == 9 && (
                <>
                  <span
                    style={{
                      marginRight: 10,
                      marginBottom: 5,
                      color: "black",
                    }}
                    className={classes.title}
                  >
                    <b> Assigned Tray Barcode : </b>{" "}
                    <span
                      style={{
                        marginLeft: 5,
                      }}
                    >
                      {this.props.values.salesData[0].trayLabel ||
                        "Not Assigned"}
                    </span>
                  </span>
                  {/* <span  style={{ marginRight: 10,marginBottom:5,color:"black"}} className={classes.title}>
                       
                  </span> */}
                  <Divider
                    style={{
                      width: "100%",
                      opacity: 0.5,
                      margin: 10,
                    }}
                  />
                </>
              )}
              {(this.props.values.salesData[0].statusId == 7 ||
                this.props.values.salesData[0].statusId == 8 ||
                this.props.values.salesData[0].statusId == 14 ||
                this.props.values.salesData[0].statusId == 15 ||
                this.props.values.salesData[0].statusId == 16) && (
                <CustomDataGrid
                  columns={
                    this.props.values.salesData[0].statusId == 7 ||
                    this.props.values.salesData[0].statusId == 15 ||
                    this.props.values.salesData[0].statusId == 16
                      ? this.state.dispatchColumns
                      : this.state.shipmentColumns
                  }
                  rows={[this.props.values.salesData[0]]}
                />
              )}
              <CustomDataGrid
                columns={this.state.columns}
                rows={this.props.rows}
              />
              <>
                {this.props.values.traybarCodeDisabled == false && (
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="baseline"
                    spacing={1}
                    style={{ marginBottom: 8 }}
                  >
                    <Grid item xs={2}>
                      {isTrayAssigned == 1 ? (
                        <Paper
                          className={classes.paper}
                          style={{
                            marginTop: 8,
                            marginLeft: 10,
                          }}
                        >
                          <div
                            style={{
                              fontSize: 14,
                              padding: 10.5,
                              textAlign: "center",
                            }}
                          >
                            {trayLabel}
                            <IconButton style={{ height: 14, color: "orange" }}>
                              <EditOutlinedIcon
                                onClick={() => {
                                  this.props.toggleEditTrayDialog();
                                }}
                              />
                            </IconButton>
                          </div>
                          <TextField
                            size="small"
                            id="outlined-basic"
                            label="Tray Barcode"
                            variant="outlined"
                            name="traybarCode"
                            style={{ display: "none" }}
                            onBlur={this.props.onFocusOutTrayBarCodeField}
                            hidden
                            disabled={
                              this.props.values.traybarCodeDisabled ||
                              isTrayAssigned == 1 ||
                              isSummaryDownloaded == 0
                            }
                            inputRef={(ref) => (this.textFieldRef = ref)}
                            value={this.props.values.traybarCode}
                            onChange={this.props.onHandleChange}
                          />
                        </Paper>
                      ) : (
                        <div style={{ marginLeft: 10, marginTop: -5 }}>
                          <TextField
                            margin="none"
                            style={{
                              marginTop: -4,
                            }}
                            size="small"
                            id="outlined-basic"
                            placeholder="Tray Barcode"
                            variant="outlined"
                            name="traybarCode"
                            onBlur={this.props.onFocusOutTrayBarCodeField}
                            hidden
                            disabled={
                              this.props.values.traybarCodeDisabled ||
                              isTrayAssigned == 1 ||
                              isSummaryDownloaded == 0
                            }
                            InputProps={{ classes: { input: classes.input1 } }}
                            inputRef={(ref) => (this.textFieldRef = ref)}
                            value={this.props.values.traybarCode}
                            onChange={this.props.onHandleChange}
                          />
                          {this.props.values.traysDataLoading ? (
                            <div
                              style={{
                                textAlign: "center",
                                marginBottom: -10,
                                marginTop: 5,
                              }}
                            >
                              <CircularProgress size={22} color="primary" />
                            </div>
                          ) : (
                            <Button
                              disabled={
                                this.props.traysDataLoading ||
                                this.props.values.traybarCodeDisabled ||
                                isTrayAssigned == 1 ||
                                isSummaryDownloaded == 0
                              }
                              onClick={(e) => this.handleTrayListOpen(e, true)}
                              color="primary"
                              style={{
                                fontSize: 12,
                                textDecoration: "underline",
                                textTransform: "capitalize",
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              View Tray Barcode List
                            </Button>
                          )}
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={2}>
                      <Paper
                        className={classes.paper}
                        style={{
                          marginTop: 8,
                          padding: 5,
                        }}
                      >
                        {/* <Button
                          // onClick={() => this.props.toggleChangeStatusConfirmationDialog()}
                          onClick={() => this.props.downloadImagesData()}
                          disabled={
                            this.props.values.imagesDataLoading ||
                            this.props.values.isDownloadImages ||
                            IsEmpty(this.props.values.selectedSalesData)
                          }
                          fullWidth
                          style={{
                            //  textDecoration: "underline",
                            fontSize: 13,
                            padding: 5,
                            textTransform: "capitalize",
                            cursor: `${
                              this.props.values.isDownloadImages
                                ? "waiting"
                                : "pointer"
                            }`,
                          }}
                          color="primary"
                        >
                          {this.props.values.isDownloadImages ? (
                            <CircularProgress size={16} />
                          ) : (
                            "Download Summary"
                          )}
                        </Button> */}
                        <CustomizedFileDownloader
                          values={this.props.values}
                          url={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsImagesSummaryDownload?orderId=${this.props.values.selectedOrder.orderId}&productId=${this.props.values.selectedSalesData.productId}&orderItemId=${this.props.values.selectedOrder.jobId}`}
                          fileName={`${this.props.values.selectedOrder.orderId}-${this.props.values.selectedSalesData.id}-${this.props.values.selectedSalesData.categoryUserLabel}.pdf`}
                          isForceCancel={this.props.values.isForceCancel}
                          getOrderId={(id) => this.props.getOrderId(id)}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={2}>
                      <Paper
                        className={classes.paper}
                        style={{
                          marginTop: 8,
                          padding: 5,
                        }}
                      >
                        <Button
                          endIcon={<PrintOutlinedIcon />}
                          onClick={() =>
                            this.props.handleChangeViewerToggle(summaryPDfFile)
                          }
                          disabled={isSummaryDownloaded == 0}
                          fullWidth
                          style={{
                            //  textDecoration: "underline",
                            fontSize: 13,
                            padding: 5,
                            textTransform: "capitalize",
                            cursor: `${
                              this.props.values.isDownloadImages
                                ? "waiting"
                                : "pointer"
                            }`,
                          }}
                          color="primary"
                        >
                          {this.props.values.isDownloadImages ? (
                            <CircularProgress size={16} />
                          ) : (
                            "print"
                          )}
                        </Button>
                      </Paper>
                    </Grid>
                  </Grid>
                )}
              </>
            </CardContent>
          </Card>
        )}
      </React.Fragment>
    );
  }
}

SalesTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  getImagesOrderIdAndProduct: PropTypes.func,
  columns: PropTypes.array,
  rows: PropTypes.array,
  printBarcode: PropTypes.func,
  getTraysData: PropTypes.func,
};

SalesTab.defaultProps = {
  values: {},
  getImagesOrderIdAndProduct: (fn) => fn,
  getTraysData: (fn) => fn,
  columns: [],
  rows: [],
  printBarcode: (fn) => fn,
};

export default withStyles(useStyles)(SalesTab);
